// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__NFdaN","content":"styles_content__exsQq","selectAll":"styles_selectAll__2Fiq_"};